module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAABWUlEQVQ4T6WSwStEYRTFz3kfsaUxJt+zVpSVEhskaxs21jZW7NhImdWU0PgLWOM/EGXPlLInH4v3mBoSC99Rw2ie91hwt7ffObdzD/GPYTMbheE4pCLJOFNTuso5t9TYJWFrtyTt5W9vz7PgyNrjLucmEvCn4zSAMUiXIKMsmMCMgH0C8YVzpbpzZO0ZvJ9XEPjfIjBS1xs5bIAQ0l4djsPwOHdz83XOTwJP+Xz3izGjNGYwAE5SsID2akdHW5ZAZ7VaA6D7MFxLwbG1kwBWQD5lwIR0l3NuIQFH1lbo/bqCYFZAKe9c5Ye0TyltiJwzUrl+9n2hMCBjhkDOee+LAbkE0jQLSCoD2CawSeD5yLnD9J+B3V+c039uOEQfJTkIyEWQLYnTpR0Bq6mSJOC/Osc9Pcsg+0hefQ/MS4bASM65qcxuA+BdodBvjGnNSvv18fG6t1Z7aOzeAV9UpGqR0hYqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon_b1_on.png
// module id = Zt8i
// module chunks = 14 17